/*
 * AOS (animate-on-scroll) - REPLACED WITH A NO-OP STUB, 2026-08-28
 *
 * Why: assets/css-vendor-aos.css was emptied on 2026-08-19 because it was the
 * source of a real bug - it set [data-aos]{opacity:0} and the library failed to
 * add .aos-animate to 9 of 41 wrappers, so product sections rendered BLANK to
 * anyone scrolling fast or landing mid-page. With no CSS attached, the 14KB
 * library was only adding classes nothing reads.
 *
 * It is a STUB, not an empty file, on purpose. Emptying it completely threw
 * "Uncaught ReferenceError: AOS is not defined" from js-main.js - not every
 * call site is guarded by `window.AOS &&`, and an uncaught error there can stop
 * the rest of that script from running.
 *
 * These no-ops keep every call site safe at ~0 cost.
 *
 * TO RESTORE SCROLL ANIMATIONS: restore BOTH this file and css-vendor-aos.css
 * from version history, then re-test the blank-section bug before publishing.
 */
window.AOS = {
  init: function () {},
  refresh: function () {},
  refreshHard: function () {}
};
